export default function Django_Tags() {
  return <div>Django_Tags Component</div>;
}
